import React from "react";
import { Box, Typography } from "@mui/material";
import FormButton from "../FormButton";

interface InjuryStepProps {
  treatedBy: string;
  onChange: (field: string, value: string) => void;
}

const InjuryStep: React.FC<InjuryStepProps> = ({ treatedBy, onChange }) => {
  return (
    <>
      <Typography variant="h6" align="center" sx={{ color: "#c6c6c6", mb: 2 }}>
        Question 1 out of 5
      </Typography>

      <Typography variant="h6" align="center" sx={{ mb: 3 }}>
        1. How bad was your car accident?
        <span style={{ color: "red" }}>*</span>
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <FormButton
          isSelected={treatedBy === "YES"}
          onClick={() => {
            onChange("treatedBy", "YES");
            onChange("physicalInjury", "YES");
          }}
        >
          I was injured
        </FormButton>

        <FormButton
          isSelected={treatedBy === "NO"}
          onClick={() => {
            onChange("treatedBy", "NO");
            onChange("physicalInjury", "NO");
          }}
        >
          I was not injured at all
        </FormButton>
      </Box>
    </>
  );
};

export default InjuryStep;
